import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

declare let google: any;

@Injectable({
  providedIn: 'root'
})
export class GooglePlacesService {

  private _service: any = new google.maps.places.AutocompleteService();
  private config: any = environment;

  constructor() { }

  /**
   *  Find place by given query
   * @param query Direction to find
   */
  async findDiection(query: string) {
    return new Promise((resolve, reject) => {
      this._service.getPlacePredictions({
        input: query,
        componentRestrictions: {
          country: this.config.enabledCountries
        }
      }, (predictions, status) => {
        if (status !== google.maps.places.PlacesServiceStatus.OK)
          return resolve([]);

        console.log('1', predictions);
        const results = predictions.map((prediction) => {
          const _item: any = {
            value: prediction.structured_formatting.main_text ?
              prediction.structured_formatting.main_text : prediction.structured_formatting.secondary_text,
            address: prediction.structured_formatting.secondary_text,
            place_id: prediction.place_id
          };
          return _item;
        });

        return resolve(results);
      });
    });
  }
}
